import { Component } from "@angular/core";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@Component({
    selector: 'app-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrl: './splash-screen.component.scss',
    imports: [ProgressSpinnerModule]
})
export class SplashScreenComponent {

}